import { Box } from '@mui/material';

import { ReportWidgetChart } from '../ReportWidgetChart';
import { ReportWidgetTable } from '../ReportWidgetTable';

import type { ComposableWidgetLayoutProps } from '../../model/types';

export const ComposableWidgetSideBySide = ({
    chartItems,
    visibleItems,
    visualization,
    table,
    loading,
    disableChartAnimation,
    isInitialLoading,
    isLoadingMore,
    hasMore,
    handleLoadMore,
    loadMoreCount,
    canCollapse,
    handleCollapse,
    itemColors,
    rowClickHandler,
    detailsClickHandler,
    chartItemClickHandler,
    hoveredItemId,
    tableActiveItemId,
    chartHoverHandler,
    tableRowHoverHandler,
    loadMoreHoverHandler,
}: ComposableWidgetLayoutProps): JSX.Element => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '24px',
            alignItems: 'stretch',
            minWidth: 0,
            width: '100%',
            overflow: 'visible',
        }}
    >
        <Box
            sx={{
                width: '280px',
                minWidth: '280px',
                maxWidth: '280px',
                flex: '0 0 280px',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <ReportWidgetChart
                items={chartItems}
                chartType={visualization.type}
                options={visualization.options}
                loading={loading}
                disableAnimation={disableChartAnimation}
                makeSticky={true}
                onItemClick={chartItemClickHandler}
                activeItemId={hoveredItemId ?? undefined}
                onItemHover={chartHoverHandler}
            />
        </Box>
        <Box
            sx={{
                flex: 1,
                width: 0,
                minWidth: 0,
            }}
        >
            <ReportWidgetTable
                items={visibleItems}
                columns={table.columns}
                loading={isInitialLoading}
                loadingMore={isLoadingMore}
                hasMore={hasMore}
                onLoadMore={handleLoadMore}
                canCollapse={canCollapse}
                onCollapse={handleCollapse}
                itemColors={itemColors}
                options={{
                    ...table.options,
                    loadMoreCount,
                }}
                onRowClick={rowClickHandler}
                onDetailsClick={detailsClickHandler}
                activeItemId={tableActiveItemId}
                onRowHover={tableRowHoverHandler}
                onLoadMoreHover={loadMoreHoverHandler}
            />
        </Box>
    </Box>
);
